import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { Tooltip } from 'react-wot-bootstrap'

import LackOfIndustrialResource from 'components/LackOfIndustrialResource/LackOfIndustrialResource.jsx'
import IndustrialResource from 'components/IndustrialResource/IndustrialResource.jsx'

import {
    MODERNIZATION_ALLOWED_MESSAGE,
    RESERVE_PRODUCTION_IN_PROGRESS,
    UPGRADE_COMMAND_CENTER,
} from './constants.jsx'

import styles from './UpgradeTooltip.scss'

export const UpgradeTooltip = (props) => {
    let message = MODERNIZATION_ALLOWED_MESSAGE

    if (props.strongholdLevel < props.nextLevel) {
        message = UPGRADE_COMMAND_CENTER
    } else if (props.reserveProductionInProgress) {
        message = RESERVE_PRODUCTION_IN_PROGRESS
    } else if (props.industrialResourceAvailable < props.upgradeCost) {
        const industrialResource = (
            <IndustrialResource
                value={props.upgradeCost - props.industrialResourceAvailable}
                small
            />
        )
        message = <LackOfIndustrialResource resource={industrialResource} />
    }

    return (
        <Tooltip id={props.id}>
            <div className={styles.base}>
                <div className={styles.message}>
                    {message}
                </div>
            </div>
        </Tooltip>
    )
}

UpgradeTooltip.propTypes = {
    id: PropTypes.string.isRequired,
    nextLevel: PropTypes.number.isRequired,
    upgradeCost: PropTypes.number.isRequired,
    industrialResourceAvailable: PropTypes.number.isRequired,
    reserveProductionInProgress: PropTypes.bool.isRequired,
    strongholdLevel: PropTypes.number.isRequired,
}

export const mapStateToProps = (state, { id, building, reserve }) => {
    const upgradeCost = state.settings.buildings[building.type].costs[building.level]
    const reserveInProduction = state.clanReserves[reserve.type].filter(reserve => (
        reserve.productionEnds !== null
    )).find(
        reserve => reserve.productionEnds > Date.now()
    )
    return {
        id,
        nextLevel: (building.level + 1),
        upgradeCost,
        industrialResourceAvailable: state.clan.industrial_resource,
        reserveProductionInProgress: (reserveInProduction !== undefined),
        strongholdLevel: state.stronghold.level,
    }
}

export default connect(mapStateToProps)(UpgradeTooltip)



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/UpgradeTooltip/UpgradeTooltip.jsx